import { requestUnAuth } from './request'

export const createApplication = (data) => {
  return requestUnAuth({
    url: 'applications',
    method: 'POST',
    body: data
  })
}
